import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { DataDirectoryHero } from '../components/data-directory/DataDirectoryHero';
import { DataDirectoryCategoryBrowser } from '../components/data-directory/DataDirectoryCategoryBrowser';
import { DataDirectoryCustomCta } from '../components/data-directory/DataDirectoryCustomCta';
import { DataDirectoryValueProps } from '../components/data-directory/DataDirectoryValueProps';
import { DataDirectoryFAQ } from '../components/data-directory/DataDirectoryFAQ';
import { DataDirectoryCta } from '../components/data-directory/DataDirectoryCta';
export function DataDirectory() {
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="min-w-full bg-slate-50/50 ecom-aeonik flex flex-col min-h-screen" style={{
    fontFamily: 'Aeonik, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  }} data-id="element-6570">
      <Navbar data-id="element-6571" />
      <main className="flex-grow pt-12 pb-24 space-y-12 md:space-y-24" data-id="element-6572">
        <DataDirectoryHero searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-6573" />
        <DataDirectoryCategoryBrowser searchQuery={searchQuery} data-id="element-6574" />
        <DataDirectoryCustomCta data-id="element-6575" />
        <DataDirectoryValueProps data-id="element-6576" />
        <DataDirectoryFAQ data-id="element-6577" />
        <DataDirectoryCta data-id="element-6578" />
      </main>
      <Footer data-id="element-6579" />
    </div>;
}